import axios from "axios";

export const getFrequenzeApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/frequenze/`);
}

export const getFrequenzaByIdApi = (id) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/frequenze/${id}`);
}

export const aggiornaFrequenzaApi = (id, frequenza) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/frequenze/${id}`, frequenza);
}

export const aggiungiFrequenzaApi = (frequenza) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/frequenze/`, frequenza);
}

export const rimuoviFrequenzaApi = (id) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/frequenze/${id}`);
}